export enum OperationStatus {
    DEFAULT,
    INVEST_BTC,
    FREE_ROLL,
    MULTIPLY_BTC,
    PLAY_BTC_LOTTERY
}